import {FC, ReactNode, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useOnClickOutside} from 'usehooks-ts'
import Tooltip from '../common/Tooltip'
import SimpleBar from 'simplebar-react'
import SVGIcon from './SVGIcon'

export type IVisibleColumnsOption = {
    value: string | number
    label: string
    icon?: string
}

type IMultiSelectDropdownProps = {
    options: Array<IVisibleColumnsOption>
    selected: Array<string | number>
    toggleOption: ICallbackFunction
    forLabel: string
    tooltipTxt?: string
    visibletooltip?: boolean
}

type ICallbackFunction = (value: string | number) => void

const MultiSelectDropdown: FC<IMultiSelectDropdownProps> = ({
    options,
    selected,
    toggleOption,
    forLabel,
    tooltipTxt,
    visibletooltip,
}): ReactNode => {
    const {t} = useTranslation()
    const ref = useRef(null)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const singleSelectedOption = options.find(
        (element: IVisibleColumnsOption) => selected.length === 1 && element.value === selected[0]
    )

    const handleOpen = () => {
        setIsOpen(!isOpen)
    }

    const handleSelect = (value: string | number) => {
        toggleOption(value)
    }

    useOnClickOutside(ref, () => {
        setIsOpen(false)
    })

    return (
        <div ref={ref} className={'c-multi-select-dropdown' + (isOpen ? ' c-multi-select-dropdown__active' : '')}>
            <div
                className="c-multi-select-dropdown__selected flex c-multi-select-dropdown__selected-type"
                onClick={handleOpen}>
                {selected.length === 0 && <div className="product flex">{t('label.dropdown.select')}</div>}

                {selected.length === 0 && visibletooltip === false && tooltipTxt && (
                    <Tooltip tooltiptext={tooltipTxt} />
                )}

                {selected.length === 1 && singleSelectedOption && (
                    <div className="product flex">{t(singleSelectedOption.label)} </div>
                )}

                {selected.length >= 2 && (
                    <div className="product flex">{t('label.dropdown.select', {count: selected.length})}</div>
                )}

                {selected.length >= 1 && visibletooltip === true && tooltipTxt && <Tooltip tooltiptext={tooltipTxt} />}

                <span className="check">
                    <SVGIcon id={'check-icon-black'} className={''} width={16} height={24} fill={'#414141'} />
                </span>
            </div>
            <div className="welcome-wrapper scrollable-block">
                <ul className="c-multi-select-dropdown__options sticky-to-left">
                    <SimpleBar
                        style={{maxHeight: '430px'}}
                        autoHide={false}
                        forceVisible={false}
                        scrollbarMinSize={0}
                        scrollbarMaxSize={0}>
                        {options.map((option: IVisibleColumnsOption, index: number) => {
                            return (
                                <li
                                    key={'visible_column_option_idx_' + index.toString()}
                                    className="c-multi-select-dropdown__option"
                                    onClick={() => handleSelect(option.value)}>
                                    <label className=" flex" htmlFor={'visible_column_option_idx_' + index.toString()}>
                                        <input
                                            id={forLabel + '_' + option.value.toString()}
                                            type="checkbox"
                                            checked={selected.includes(option.value)}
                                            className="c-multi-select-dropdown__option-checkbox"
                                            readOnly
                                        />
                                        <span className="check-mark"></span>
                                        <span className="check-name">
                                            <span className="name-product">{t(option.label)}</span>
                                            <span
                                                className={
                                                    'check-label ' + (option.icon ? 'umbrella ' + option.icon : '')
                                                }></span>
                                        </span>
                                    </label>
                                </li>
                            )
                        })}
                    </SimpleBar>
                </ul>
            </div>
        </div>
    )
}

export default MultiSelectDropdown
